import { nftAdress, nftAbi } from "../../contract/contract";
import { loadWeb3 } from ".././Home/Web3/Api";
import Web3 from "web3";
export const getNftData = async (account) => {
  // Ensure web3 is loaded before creating the contract instance
  window.web3 = new Web3(window.ethereum);
  const web3 = window.web3;
  const contract = new web3.eth.Contract(nftAbi, nftAdress);
  const tokenIds = await contract.methods.walletOfOwner(account).call();
  const nftData = await Promise.all(tokenIds.map(async (tokenId) => {
    const tokenURI = await contract.methods.tokenURI(tokenId).call();
    const response = await fetch(tokenURI);
    const metadata = await response.json();
    return {
      Id: tokenId,
      image: metadata.image,
      title: metadata.name,
      description: metadata.description,
    };
  }));

  return nftData;
};
